import * as React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Popover,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Grid,
  Pagination,
  Stack,
  Backdrop,
  ListItem,
  ListItemText,
  ListItemButton,
  List,
  Typography,
  Checkbox,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AsyncSelect from "react-select/async";
import AddIcon from "@mui/icons-material/Add";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, useEffect, useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import {
  GetUserGroupList,
  DeleteUserGroup,
  GetUserGroupMemberList,
  TransferMembersToAnotherUserGroup,
} from "../../Services/UserGroupService";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import { PreferencesContext } from "../../PreferencesContext";
import { AlertType } from "../../shared/Modal/AlertType";
import MissingConsumer from "../../Components/MissingConsumer";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { styled, alpha, useTheme } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DownloadIcon from "@mui/icons-material/Download";
import { KeyboardArrowDownSharp } from "@mui/icons-material";
import SplashComponent from "../../Navigation/splash";
import { AsyncCustomSelect } from "../../Components/CustomSelect";
import { tr } from "date-fns/locale";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import ShortcutButton from "../../Components/ShortcutButton";
import {
  ListPaginationOrContent,
  TableRowsSkeleton,
} from "../../Components/DashboardSkeleton/DashboardSkeleton";
import { useListLoading } from "../../Components/DashboardSkeleton/useListLoading";

interface Data {
  id: number;
  code: string;
  Name: string;
  none: string;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc" | "";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

interface EnhancedTableProps {
  numSelected: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  return (
    <TableHead
      className="table-header-color"
      sx={{
        '& .MuiTableCell-root': {
          backgroundColor: '#f5f5f5',
        }
      }}
    >
      <TableRow>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="left"
        >
          {"Group"}
        </TableCell>
        <TableCell sx={{ width: "5%" }}></TableCell>
      </TableRow>
    </TableHead>
  );
}

const UserGroup: any = {
  userGroupCollection: [],
};
const edService = new EncryptDecryptService();

const parameters: any = {
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
};

interface IUpdatedGroup {
  label: "";
  userGroupId: number;
  value: number;
}

export default function UserGroupList() {
  const updatedGroupColl: IUpdatedGroup = {
    label: "",
    userGroupId: 0,
    value: 0,
  };

  interface SubmitDetail {
    oldUserGroupId: number;
    initUserGroupId: number;
    initUserGroupName: string;
    updatedGroupData: [IUpdatedGroup];
  }

  const formInitialValues: SubmitDetail = {
    oldUserGroupId: 0,
    initUserGroupId: 0,
    initUserGroupName: "",
    updatedGroupData: [updatedGroupColl],
  };

  const UserGroupdata = {
    title: "Add UserGroup",
    button: "Save",
    userGroupId: 0,
    isAddPopUp: false,
  };

  const handleAddUserGroup = (e: any) => {
    let encUserGroupId: any = edService.encrypt(0);
    e.preventDefault();
    navigate(
      {
        pathname: "/user-group-save",
        search: `?q=${encodeURIComponent(encUserGroupId)}`,
      },
      {
        state,
      }
    );
  };
  
  const handleOpenMore = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: any,
    item: any
  ) => {
    setAnchorEl3(event.currentTarget);
    setUserGroupId(id);
    setUserGroupName(item.label);
  };

  const handleCloseMore = () => {
    setAnchorEl3(null);
  };
  
  const theme = useTheme();
  const { userContext, updateUserContext } = useContext(PreferencesContext);

  // ── Sticky Header Refs ────────────────────────────────────────────────────
  const BOTTOM_GAP = 30;
  const pageContainerRef = React.useRef<HTMLDivElement>(null);
  const [containerTop, setContainerTop] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [isLayoutReady, setIsLayoutReady] = useState(false);
  const enableStickyHeader = userContext?.enableStickyHeader || false;
  const isLargeScreen = useMediaQuery('(min-width:1024px)');
  const shouldApplySticky = enableStickyHeader && isLargeScreen;

  const findAppFooter = () =>
    (document.querySelector("footer") as HTMLElement) ||
    (document.querySelector('[class*="footer" i]') as HTMLElement) ||
    (document.querySelector('[id*="footer" i]') as HTMLElement) ||
    null;

// ── useEffect for measurements ──
React.useEffect(() => {
  if (!shouldApplySticky) {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    setIsLayoutReady(false);
    return;
  }
  
  const el = pageContainerRef.current;
  if (!el) return;

  const measureLayout = () => {
    // Small delay to ensure DOM is ready
    const rect = el.getBoundingClientRect();
    const footerEl = findAppFooter();
    const footerH = footerEl 
      ? footerEl.getBoundingClientRect().height + BOTTOM_GAP 
      : BOTTOM_GAP;
    
    setContainerTop(rect.top);
    setFooterHeight(footerH);
    setIsLayoutReady(true);
  };

  // Use requestAnimationFrame for first measurement
  requestAnimationFrame(measureLayout);
  
  // Backup measurement after a short delay
  const timer = setTimeout(measureLayout, 100);

  const handleResize = () => measureLayout();
  window.addEventListener("resize", handleResize);

  let resizeObserver: ResizeObserver | null = null;
  const footerEl = findAppFooter();
  if (footerEl && typeof ResizeObserver !== "undefined") {
    resizeObserver = new ResizeObserver(() => measureLayout());
    resizeObserver.observe(footerEl);
  }

  return () => {
    clearTimeout(timer);
    window.removeEventListener("resize", handleResize);
    if (resizeObserver) resizeObserver.disconnect();
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    setIsLayoutReady(false);
  };
}, [shouldApplySticky]);

// ── useEffect for body scroll ──
React.useEffect(() => {
  if (!shouldApplySticky || !isLayoutReady) {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    return;
  }
  
  const prevBodyOverflow = document.body.style.overflow;
  const prevHtmlOverflow = document.documentElement.style.overflow;
  document.body.style.overflow = "hidden";
  document.documentElement.style.overflow = "hidden";
  
  return () => {
    document.body.style.overflow = prevBodyOverflow || "";
    document.documentElement.style.overflow = prevHtmlOverflow || "";
  };
}, [shouldApplySticky, isLayoutReady]);
  // ── End Sticky Header ──

  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const mediumDevice = useMediaQuery("(max-width:899px)");
  const matches = useMediaQuery("(max-width:599px)");
  const matchesformobile = useMediaQuery("(max-width:375px)");
  const [state, setState] = useState(UserGroupdata);
  const [param, setParam] = useState(parameters);
  const [submitData, setSubmitData] = useState(formInitialValues);
  const [anchorEl, setAnchorEl3] = useState<HTMLButtonElement | null>(null);
  const [selected, setSelected] = useState<readonly number[]>(
    UserGroup.userGroupCollection
  );
  const [userGroupId, setUserGroupId] = useState(null);
  const [userGroupName, setUserGroupName] = useState(null);
  const open = Boolean(anchorEl);
  const [totalCount, setTotalCount] = useState(0);
  const [pageStartIndex, setPageStartIndex] = useState(1);
  const [pageEndIndex, setPageEndIndex] = useState(1);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [value, setValue] = useState("");
  const [openDeleteModal, setopenDeleteModal] = React.useState(false);
  const [order, setOrder] = useState<Order>("");
  const [orderBy, setOrderBy] = useState<keyof Data>("none");
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE);
  const [resultData, setResultData] = useState(UserGroup);
  const [page_Index, setPage_Index] = useState(1);
  const [counData, setCounData] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const { isListLoading, runListLoad } = useListLoading(true);
  const [isAllowAdd, setAllowAdd] = useState(true);

  const [openListOfDeletePersonModal, setOpenListOfDeletePersonModal] =
    useState(false);
  const [openUserGroupMemberList, setOpenUserGroupMemberList] = useState(false);
  const [Curr_page, setCurrPage] = useState(1);

  const [userGroupMemberList, setUserGroupMemberList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [checkedItems, setCheckedItems] = useState([...userGroupMemberList]);
  const isSelected = (id: number) => selected.indexOf(id) !== -1;

  const validateSchema = Yup.object().shape({
    updatedGroupData: Yup.array().of(
      Yup.object().shape({
        value: Yup.number()
          .min(1, "Please select a user group.")
          .required("Please select a user group."),
        userGroupId: Yup.number()
          .min(1, "Please select a user group.")
          .required("Please select a group ID."),
        label: Yup.string(),
      })
    ),
  });

  const handleOpenDeleteUserGroupModal = (userGroupId) => {
    if (userGroupMemberList.length > 0) {
      openUserGroupList(userGroupId);
    } else {
      setopenDeleteModal(true);
    }
  };

  const handleCheckSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = resultData.userGroupCollection.map(
        (n: any) => n.userGroupId
      );
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // Pagination
  const handleChangePageNew = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    if (Curr_page !== value) {
      setCurrPage(value);
      setPage_Index(value);
      setParam({ ...param, pageIndex: value });
      fetchUserGroupList();
    }
  };

  // Searching
  function searchValue(val: any) {
    if (val === "") {
      setValue("");
    }
    setPage_Index(1);
    setParam({ ...param, searchValue: val.toString(), pageIndex: 1 });
  }

  let navigate = useNavigate();

  async function fetchUserGroupList() {
    await runListLoad(async () => {
      try {
        if (
          userContext != null &&
          userContext.consumerId != null &&
          userContext.consumerId > 0
        ) {
          setAllowAdd(true);
        } else {
          setAllowAdd(false);
        }
        let params = new URLSearchParams();
        params.append("consumerId", userContext.consumerId.toString());
        params.append("firmId", userContext.firmId.toString());
        params.append("branchId", userContext.branchId.toString());
        params.append("pageIndex", page_Index.toString());
        params.append("pageSize", param.pageSize);
        params.append("sortColumn", param.sortColumn);
        params.append("sortDirection", param.sortDirection);
        params.append("searchValue", param.searchValue);
        params.append("mode", "");
        const result: any = await GetUserGroupList(params);
        if (result && result.data.data) {
          let dataCount = result.data.data.totalCount;
          let userGroupInfo = result.data.data;
          let showDataCount = Math.ceil(dataCount / PAGE_SIZE);

          setResultData(userGroupInfo);
          setCounData(showDataCount);
          let startIndex = (page_Index - 1) * param.pageSize + 1;
          let endIndex =
            (page_Index - 1) * param.pageSize +
            (result.data.data.userGroupCollection
              ? result.data.data.userGroupCollection.length
              : 0);

          setPageStartIndex(startIndex);
          setPageEndIndex(endIndex);
          setTotalCount(dataCount);
        } else {
          console.log("Error");
        }
      } catch (e: any) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage:
            typeof e === "string" ? (e as string) : (e?.message as string),
          alertType: AlertType.Error,
        });
      }
    });
  }

  async function handleDeleteUserGroup(userGroupid: any) {
    try {
      let DeleteData = {
        ids: userGroupid.toString(),
        consumerId: userContext.consumerId,
        firmId: userContext.firmId,
        branchId: userContext.branchId,
        isDeleted: true,
        dataManagedBy: userContext.userId,
      };
      const result: any = await DeleteUserGroup(DeleteData);
      if (result) {
        fetchUserGroupList();
        setAnchorEl3(null);
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Success,
        });
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
    setopenDeleteModal(false);
  }

  async function openUserGroupList(userGroupid: any) {
    try {
      setLoading(true);
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("userGroupId", userGroupid.toString());
      const result: any = await GetUserGroupMemberList(params);
      setAnchorEl3(null);
      if (result?.data?.data?.length > 0) {
        setUserGroupMemberList(result.data.data);
        setOpenListOfDeletePersonModal(true);
      } else {
        setopenDeleteModal(true);
      }
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  }

  const handleCloseDeleteUserGroupModal = () => {
    setOpenListOfDeletePersonModal(false);
    setopenDeleteModal(false);
    fetchUserGroupList();
    setAnchorEl3(null);
  };

  async function handleEditUserGroup(userGroupId: any) {
    try {
      let encUserGroupId: any = edService.encrypt(userGroupId);
      navigate(
        {
          pathname: "/user-group-save",
          search: `?q=${encodeURIComponent(encUserGroupId)}`,
        },
        {
          state: {
            title: " Edit UserGroup",
            button: "Update",
            userGroupId: userGroupId,
            isAddPopUp: "false",
          },
        }
      );
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    const updatedItems: any = userGroupMemberList.map((item: any) => ({
      ...item,
      isDeleted: false,
    }));

    setCheckedItems(updatedItems);
    setUserGroupMemberList(updatedItems);
  };

  const handleCheckboxChange = (index) => {
    const updatedItems: any = userGroupMemberList.map((item: any, idx) =>
      idx === index ? { ...item, isDeleted: false } : item
    );

    setCheckedItems(updatedItems);
    setUserGroupMemberList(updatedItems);

    const allChecked: any = updatedItems.every((item) => item.isDeleted);
    setSelectAll(allChecked);
  };

  const handleDropdownChange = (selectedOption: any, props: any) => {
    const isChecked = true;
    setSelectAll(isChecked);

    const updatedItems: any = userGroupMemberList.map((item: any) => ({
      ...item,
      isDeleted: isChecked,
    }));
    setCheckedItems(updatedItems);
    setUserGroupMemberList(updatedItems);

    props.setFieldValue("initUserGroupId", selectedOption.value);
    props.setFieldValue("initUserGroupName", selectedOption.label);
    props.setFieldValue("oldUserGroupId", userGroupId);

    userGroupMemberList.forEach((item: any, index: number) => {
      props.setFieldValue(
        `updatedGroupData[${index}].userGroupId`,
        selectedOption.value
      );
      props.setFieldValue(
        `updatedGroupData[${index}].label`,
        selectedOption.label
      );
      props.setFieldValue(
        `updatedGroupData[${index}].value`,
        item.invitationId
      );
    });
  };

  useEffect(() => {
    fetchUserGroupList();
    setSelected([]);
    let e: any = document.getElementById("root");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }, [param]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "F2") {
        event.stopImmediatePropagation();
        handleAddUserGroup(event as any);
      } else if (event.key === "Escape") {
        event.stopImmediatePropagation();
        navigate("/dashboard");
      }
    };

    window.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [navigate]);

  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const openExportType = Boolean(anchorEl2);
  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };

  async function submitForm(values) {
    const oldDetail = values;
    const userGroupUpdatedData = values.updatedGroupData;

    let data = {
      consumerId: userContext.consumerId,
      firmId: userContext.firmId,
      branchId: userContext.branchId,
      oldUserGroupId: oldDetail.oldUserGroupId,
      dataManagedBy: userContext.userId,
      transferMembersData: JSON.stringify(userGroupUpdatedData),
    };

    try {
      const resultOfTransferMembers: any =
        await TransferMembersToAnotherUserGroup(data);
      setOpenListOfDeletePersonModal(false);
      setSelectAll(false);
      fetchUserGroupList();
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: resultOfTransferMembers.message,
        alertType: AlertType.Success,
      });
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error as string,
        alertType: AlertType.Error,
      });
    }
  }

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <SplashComponent />
      </Backdrop>
      <Title pageTitle="UserGroups" />
      
      <Box
        className="boxContainer"
        ref={pageContainerRef}
        sx={{
          "& > :not(style)": {
            width: "100%",
          },
          ...(shouldApplySticky && isLayoutReady
            ? {
                height: `calc(100vh - ${containerTop}px - ${footerHeight}px)`,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                justifyContent: "stretch",
              }
            : {}),
            transition: 'height 0.15s ease-out',
        }}
      >
        {userContext.consumerId > 0 ? (
          <Grid
            sx={
              shouldApplySticky && isLayoutReady
                ? {
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    minHeight: 0,
                    overflow: "hidden",
                  }
                : undefined
            }
          >
            {/* HEADER - Fixed */}
            <Grid
              className="title-button-responsive"
              item
              xs={6}
              md={3}
              sx={{
                display: "flex !important",
                justifyContent: "space-between",
                alignItems: "center",
                ...(shouldApplySticky
                  ? {
                      flexShrink: 0,
                    }
                  : {}),
              }}
            >
              <h4 className="page-title">User Groups</h4>
              <Grid
                item
                xs={6}
                md={3}
                marginRight={0}
                gap={2}
                display={"flex"}
                textAlign="end"
                paddingTop="0px"
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAddUserGroup}
                  size="medium"
                >
                  <ShortcutButton label="F2" variant="dark" />
                  Add
                </Button>
                {!matchesformobile && (
                  <Button
                    variant="outlined"
                    onClick={() => navigate("/dashboard")}
                    size="medium"
                  >
                    <ShortcutButton label="ESC" />
                    Back
                  </Button>
                )}
              </Grid>
            </Grid>

            {matchesformobile && (
              <Grid
                item
                xs={6}
                md={3}
                gap={2}
                display={"flex-end"}
                mt={1}
                marginRight={0}
                textAlign="end"
                paddingTop="0px"
              >
                <Button
                  variant="outlined"
                  onClick={() => navigate("/dashboard")}
                  size="medium"
                >
                  <ShortcutButton label="ESC" />
                  Back
                </Button>
              </Grid>
            )}

            {/* PAPER SECTION - Takes remaining space */}
            <Grid
              className="paper top-space"
              sx={
                shouldApplySticky && isLayoutReady
                  ? {
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      minHeight: 0,
                      overflow: "hidden",
                      justifyContent: "flex-start",
                      alignItems: "stretch",
                      width: "100%",
                    }
                  : undefined
              }
            >
              <Paper
                elevation={4}
                className="paper-container"
                sx={{
                  overflow: "hidden",
                  ...(shouldApplySticky && isLayoutReady
                    ? {
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minHeight: 0,
                        justifyContent: "flex-start",
                        alignItems: "stretch",
                      }
                    : {}),
                }}
              >
                {/* Search bar - Fixed */}
                <Grid
                  container
                  rowGap={1}
                  className="search-space"
                  sx={
                    shouldApplySticky
                      ? {
                          flexShrink: 0,
                          backgroundColor: "#fff",
                          py: 1,
                        }
                      : undefined
                  }
                >
                  <Grid item xs={12} sm={6} md={8} lg={8} xl={8}>
                    {matches ? (
                      <TextField
                        autoFocus
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            searchValue(value);
                          }
                        }}
                        placeholder="Search..."
                        type="text"
                        variant="outlined"
                        size="small"
                        fullWidth
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton onClick={() => searchValue("")}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: value && (
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => searchValue("")}
                            >
                              <ClearIcon />
                            </IconButton>
                          ),
                        }}
                      />
                    ) : (
                      <TextField
                        autoFocus
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            searchValue(value);
                          }
                        }}
                        placeholder="Search..."
                        type="text"
                        variant="outlined"
                        size="small"
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton onClick={() => searchValue(value)}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: value && (
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => searchValue("")}
                            >
                              <ClearIcon />
                            </IconButton>
                          ),
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <Grid
                      sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          cursor: "pointer",
                        }}
                      ></Box>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Table - Scrollable */}
                <TableContainer
                  sx={{
                    width: "100%",
                    overflowX: "auto",
                    ...(shouldApplySticky && isLayoutReady
                      ? {
                          flex: 1,
                          minHeight: 0,
                          overflowY: "auto",
                          display: "flex",
                          flexDirection: "column",
                        }
                      : {
                          maxHeight: "none",
                          overflowY: "visible",
                        }),
                  }}
                >
                  <Table
                    stickyHeader={shouldApplySticky}
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}
                    sx={{ width: "100%" }}

                  >
                    <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleCheckSelectAll}
                      rowCount={resultData.userGroupCollection.length}
                    />
                    <TableBody sx={{ flex: 1 }}>
                      {isListLoading ? (
                        <TableRowsSkeleton rows={8} />
                      ) : (
                        <>
                      {stableSort(
                        resultData.userGroupCollection,
                        getComparator(order, orderBy)
                      )
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((item: any, index: any) => {
                          const isItemSelected = isSelected(item.userGroupId);
                          return (
                            <TableRow hover key={item.userGroupId}>
                              <TableCell
                                onClick={() =>
                                  item.consumerId && mediumDevice
                                    ? handleEditUserGroup(item.userGroupId)
                                    : null
                                }
                                sx={{
                                  display: {
                                    xs: "table-cell",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="left"
                              >
                                {item.consumerId > 0 ? (
                                  <Button
                                    disableRipple
                                    color="inherit"
                                    onClick={() =>
                                      handleEditUserGroup(item.userGroupId)
                                    }
                                    className="manuButton-link"
                                    sx={{
                                      backgroundColor: "transparent",
                                    }}
                                  >
                                    <span className="text-link">
                                      {item.code ? item.code + " - " : ""}
                                      <span>{item.name}</span>
                                    </span>
                                  </Button>
                                ) : (
                                  <Button
                                    disableRipple
                                    color="inherit"
                                    className="init-button-admin"
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                      cursor: "default",
                                      backgroundColor: "transparent",
                                    }}
                                  >
                                    {item.code === ""
                                      ? item.name
                                      : item.code + " - " + item.name}
                                  </Button>
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "table-cell",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="center"
                                height={55}
                              >
                                {item.consumerId > 0 ? (
                                  <Tooltip title="More" placement="top">
                                    <IconButton
                                      onClick={(e: any) =>
                                        handleOpenMore(
                                          e,
                                          item.userGroupId,
                                          item
                                        )
                                      }
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                  </Tooltip>
                                ) : (
                                  <></>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {resultData.userGroupCollection.length <= 0 ? (
                        <TableRow hover tabIndex={-1} key={"0"}>
                          <TableCell colSpan={6} align="center">
                            No record(s) found
                          </TableCell>
                        </TableRow>
                      ) : (
                        <></>
                      )}
                      </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination - Fixed */}
                <ListPaginationOrContent
                  loading={isListLoading}
                  hasRows={resultData.userGroupCollection.length > 0}
                >
                  <Grid
                    container
                    paddingTop={1}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={
                      shouldApplySticky && isLayoutReady
                        ? {
                            flexShrink: 0,
                            backgroundColor: "#fff",
                            pb: 1,
                          }
                        : undefined
                    }
                  >
                    <Grid item xs={12} sm={6} className="pagination-label">
                      {pageStartIndex} - {pageEndIndex} of {totalCount}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack
                        component="div"
                        alignItems={mobileScreen ? " center" : "end"}
                        justifyContent={"center"}
                      >
                        <Pagination
                          color="primary"
                          count={counData}
                          page={page_Index}
                          onChange={handleChangePageNew}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </ListPaginationOrContent>
              </Paper>
            </Grid>
          </Grid>
        ) : (
          <MissingConsumer consumerId={userContext.consumerId} />
        )}
      </Box>

      <Popover
        elevation={1}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseMore}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleEditUserGroup(userGroupId)}>
              <ListItemText primary="Edit" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              className="delete-container"
              onClick={() => openUserGroupList(userGroupId)}
            >
              Delete
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>

      <Dialog
        open={openListOfDeletePersonModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCloseDeleteUserGroupModal();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="user-group-member-dialog-root"
      >
        <Formik
          initialValues={submitData}
          validationSchema={validateSchema}
          enableReinitialize
          onSubmit={(values) => {
            submitForm(values);
          }}
          validateOnChange={true}
        >
          {(props) => (
            <Form>
              <DialogContent className="user-group-member-dialogcontent">
                <DialogContentText id="alert-dialog-description">
                  WARNING! The Group <b>{userGroupName}</b> consists of the
                  following members. If you want to delete, you need to move to
                  another group.
                  <Grid container spacing={2} mt={1} className="search-space">
                    <Grid item xs={12} sm={6} md={6}>
                      <Typography>
                        Move all users to <b>{userGroupName}</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <AsyncCustomSelect
                        menuPortalTarget={document.querySelector("body")}
                        placeholder={"User Group"}
                        defaultOptions={resultData?.userGroupCollection
                          ?.filter(
                            (val) =>
                              val.consumerId !== 0 &&
                              val.userGroupId !== userGroupId
                          )
                          ?.map((val) => ({
                            ...val,
                            value: val.userGroupId,
                            label: val.label,
                          }))}
                        handleChange={(e) => handleDropdownChange(e, props)}
                        id={"initUserGroupId"}
                        FieldName={"initUserGroupId"}
                        options={resultData?.userGroupCollection
                          ?.filter(
                            (val) =>
                              val.consumerId !== 0 &&
                              val.userGroupId !== userGroupId
                          )
                          ?.map((val) => ({
                            ...val,
                            value: val.userGroupId,
                            label: val.label,
                          }))}
                        isClearable
                        isSearchable
                        isNotCreatable={true}
                        Value={props?.values?.initUserGroupId}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={0.5} className="search-space">
                    {userGroupMemberList !== undefined &&
                      userGroupMemberList.map((item: any, mainIndex) => (
                        <Grid
                          item
                          xs={12}
                          key={mainIndex}
                          sx={{
                            borderTop: "1px solid #e9e9ef",
                            "&:hover": { backgroundColor: "#f1f6fe" },
                            maxHeight: "300px",
                            overflowY: "auto",
                          }}
                        >
                          <Grid container spacing={1}>
                            <Grid item xs={12} md={6}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  height: "100%",
                                }}
                              >
                                <Typography sx={{ fontWeight: 700 }}>
                                  {item.invitedEmailId}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <AsyncCustomSelect
                                id={"userGroupId"}
                                FieldName={`updatedGroupData[${mainIndex}].userGroupId`}
                                menuPortalTarget={document.querySelector(
                                  "body"
                                )}
                                defaultOptions={resultData?.userGroupCollection
                                  ?.filter(
                                    (val) =>
                                      val.consumerId !== 0 &&
                                      val.userGroupId !== userGroupId
                                  )
                                  ?.map((val) => ({
                                    ...val,
                                    value: val.userGroupId,
                                    label: val.label,
                                  }))}
                                options={resultData?.userGroupCollection
                                  ?.filter(
                                    (val) =>
                                      val.consumerId !== 0 &&
                                      val.userGroupId !== userGroupId
                                  )
                                  ?.map((val) => ({
                                    ...val,
                                    value: val.userGroupId,
                                    label: val.label,
                                  }))}
                                handleChange={(selectedOption: any) => {
                                  props.setFieldValue(
                                    `updatedGroupData[${mainIndex}].userGroupId`,
                                    selectedOption.value,
                                    true
                                  );
                                  props.setFieldValue(
                                    `updatedGroupData[${mainIndex}].label`,
                                    selectedOption.label,
                                    false
                                  );
                                  props.setFieldValue(
                                    `updatedGroupData[${mainIndex}].value`,
                                    item.invitationId,
                                    false
                                  );
                                }}
                                Value={
                                  props.values.updatedGroupData[mainIndex]
                                    ?.userGroupId
                                }
                              />
                              {props.touched.updatedGroupData &&
                                props.touched.updatedGroupData[mainIndex]
                                  ?.userGroupId &&
                                props.errors.updatedGroupData &&
                                props.errors.updatedGroupData[mainIndex]
                                  ?.userGroupId && (
                                  <Typography className="validation-message">
                                    {
                                      props.errors.updatedGroupData[mainIndex]
                                        .userGroupId
                                    }
                                  </Typography>
                                )}
                            </Grid>
                          </Grid>
                        </Grid>
                      ))}
                  </Grid>
                </DialogContentText>
              </DialogContent>
              <DialogActions
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Button type="submit" className="button-delete">
                  Yes
                </Button>
                <Button onClick={handleCloseDeleteUserGroupModal} autoFocus>
                  No
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      <Dialog
        open={openDeleteModal}
        onClose={handleCloseDeleteUserGroupModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this User Group?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDeleteUserGroup(userGroupId)}
            className="button-delete"
          >
            Yes
          </Button>
          <Button onClick={handleCloseDeleteUserGroupModal} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}